<div class="checkbox" [class.padded]="padded">
  <mat-checkbox [color]="color" [ngModel]="value" [disabled]="disabled" (blur)="onTouch()" (ngModelChange)="value = $event">
    {{ labelKey | locLabel }}
  </mat-checkbox>
</div>
